// extracted by mini-css-extract-plugin
module.exports = {"Container":"Communication_Container__3rb5h","Title":"Communication_Title__ApG9c"};